import React from 'react';

import { Formik } from 'formik';
import { useSnackbar } from 'notistack';
import * as Yup from 'yup';

import { CONFIGS } from '../../utilities/Configs';
import { ConstructFetchBody, UrlQueryParam } from '../../utilities/Helpers';
import { TowerPhotoRequest } from '../../utilities/Types';

import { Button, TextField } from '@material-ui/core';

type Props = {
	towerPhotoRequest: TowerPhotoRequest
};

export const RequestNotesEdit = (props: Props) => {
	const { enqueueSnackbar } = useSnackbar();

	const handleSubmit = (_values, _formikBag) => {
		fetch(CONFIGS.API.ENDPOINT, ConstructFetchBody(CONFIGS.API.METHODS.REQUEST_NOTES_POST, [UrlQueryParam('token'), props.towerPhotoRequest['Location']['Table'][0]['twrid'], _values.notes])).then(
			(_response) => _response.json()
		).then(
			(_response) => {
				if (_response?.error !== undefined) {
					enqueueSnackbar(_response?.error.message, { variant: 'error' });
				}
				else {
					enqueueSnackbar('Notes saved!', { variant: 'success' });
				}
			}
		).catch(
			() => enqueueSnackbar('An unexpected error has occurred. Please try again later. If problem persists, please contact support.', { variant: 'error' })
		).finally(
			() => _formikBag.setSubmitting(false)
		);
	};

	return (
		<Formik
			initialValues={{
				notes: (props.towerPhotoRequest['RequestNotes'] || '')
			}}
			onSubmit={handleSubmit}
			validateOnBlur={false}
			validateOnChange={false}
			validationSchema={
				Yup.object().shape({
					notes: Yup.string()
				})
			}
		>
			{
				(_formik) => (
					<div className="column">
						<p className="bold">Request Notes</p>
						<TextField
							value={_formik.values.notes}
							InputLabelProps={{
								shrink: true
							}}
							variant="outlined"
							margin="dense"
							fullWidth
							multiline
							minRows={6}
							disabled={_formik.isSubmitting}
							className="notes"
							onChange={(_event) => _formik.setFieldValue('notes', _event.target.value)}
						/>
						<div className="end">
							<Button variant="contained" color="primary" disabled={_formik.isSubmitting} onClick={() => _formik.handleSubmit()}>Save</Button>
						</div>
					</div>
				)
			}
		</Formik>
	);
};